import { Injectable } from '@angular/core';
import { User } from 'types/User';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private userId: string | null = null;
  private tagId: string | null = null;
  private loggedUser: User | null = null;
  private paymentStatus: { [userId: string]: { isPaymentCompleted: boolean, paymentMethodId: string, timestamp: string } } = {};

  setUserId(userId: string): void { this.userId = userId; }
  getUserId(): string | null { return this.userId; }
  clearUserId(): void { this.userId = null; }

  setTagId(tagId: string): void { this.tagId = tagId; }
  getTagId(): string | null { return this.tagId; }
  clearTagId(): void { this.tagId = null; }

  setLoggedUser(user: User): void { this.loggedUser = user; }
  getLoggedUser(): User | null { return this.loggedUser; }
  clearLoggedUser(): void { this.loggedUser = null; }

  public setPaymentStatus(userId: string, status: { isPaymentCompleted: boolean, paymentMethodId: string, timestamp: string }): void {
    this.paymentStatus[userId] = status;
  }

  public getPaymentStatus(userId: string): { isPaymentCompleted: boolean, paymentMethodId: string, timestamp: string } | null {
    return this.paymentStatus[userId] || null;
  }

  public clearPaymentStatus(userId: string): void {
    delete this.paymentStatus[userId];
  }
}